import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-auto flex-col flex items-center" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.src,
      alt: "",
      class: "h-20"
    }, null, 8, _hoisted_2),
    _createElementVNode("div", {
      class: _normalizeClass(["bg-h-primary-500 w-[4.2rem]", _ctx.height])
    }, null, 2)
  ]))
}